import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Box, Button, Image, Menu, NumberFormatter, Text } from '@mantine/core';
import { useClickOutside, useMediaQuery } from '@mantine/hooks';
import { useState } from 'react';
import { AccountBalance, data } from '../Profile/Account/AccountBalance';
import classes from './Header.module.css';
export type SelectTokenType = {
  balance: number;
  value: number;
  symbol: string;
  tokenURI?: string;
};
export const TokenBalance: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  const [opened, setOpened] = useState(false);
  const isMobile = useMediaQuery('(max-width: 62em)');
  const ref = useClickOutside(() => setOpened(false));
  const [selectedToken, setSelectedToken] = useState<SelectTokenType>({
    symbol: 'BTC',
    tokenURI: '/assets/tokens/bitcoin.svg',
    balance: data.BTC.balance,
    value: data.BTC.value
  });
  return <Menu shadow="md" width={420} withArrow arrowSize={15} opened={opened} closeOnClickOutside transitionProps={{
    duration: 200,
    transition: 'fade-down'
  }} classNames={{
    dropdown: classes.infoDropdown,
    item: classes.infoItem
  }} radius={5}>
      <Menu.Target>
        <Button size={isMobile ? 'sm' : 'md'} variant="filled" px="sm" h={40} classNames={{
        root: classes.balanceButton,
        inner: classes.buttonInner,
        section: classes.section
      }} leftSection={<Image src={selectedToken.tokenURI} w={20} h={20} alt={selectedToken.symbol} />} rightSection={<Icons className="icon-pr-line-chevron-down" fontSize={16} fw={600} color="var(--icon-color)" />} onClick={() => setOpened(!opened)}>
          <Box w={{
          base: 28,
          sm: 30,
          md: 60
        }}>
            <Text c="prime.11" fw={700} fz={13} ta="left" truncate="end">
              <NumberFormatter value={selectedToken?.value} decimalScale={2} thousandSeparator="," decimalSeparator="." fixedDecimalScale />
            </Text>
          </Box>
        </Button>
      </Menu.Target>

      <Menu.Dropdown bg="var(--navbar-bg-color)" p={0} pos="fixed" top={85} ref={ref}>
        <AccountBalance setSelectedToken={setSelectedToken} setOpened={setOpened} />
        <Button fullWidth className={classes.walletButton} size="lg" tt="uppercase" fz={12} fw="bold" onClick={() => {
        setOpenModal(MODAL.WALLET);
        setOpened(false);
      }} leftSection={<Icons className="icon-pr-flat-wallet" fontSize={24} fw={600} />}>
          {i18n._('Wallet')}
        </Button>
      </Menu.Dropdown>
    </Menu>;
};